export default function CancelledStatus() {
  return (
    <div className="fs-n1 text--md-grey">
      <strong>Cancelled</strong>
    </div>
  )
}

CancelledStatus.propTypes = {}
